import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";

import AuthService from "../Autenticacao/services/auth.service";

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Este campo é obrigatório!
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        Este não é um e-mail válido.
      </div>
    );
  }
};

const vusername = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        O nome de usuário deve ter entre 3 e 20 caracteres.
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        A senha deve ter entre 6 e 40 caracteres.
      </div>
    );
  }
};

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeNome = this.onChangeNome.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangeUnidade = this.onChangeUnidade.bind(this);

    this.state = {
      nome: "",
      username: "",
      email: "",
      password: "",
      unidade: "",
      successful: false,
      message: ""
    };
  }

  onChangeNome(e) {
    this.setState({
      nome: e.target.value
    });
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  onChangeUnidade(e) {
    this.setState({
      unidade: e.target.value
    });
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.register(
        this.state.nome,
        this.state.username,
        this.state.email,
        this.state.password,
        this.state.unidade
      ).then(
        response => {
          this.setState({
            message: response.data.message,
            successful: true
          });
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
    }
  }

  render() {
    return (
      <div className="content">
        <div className="container">
          <div className="col-lg-4 col-md-6 ml-auto mr-auto">

            <div className="card card-container">

              <div className="card-header ">
                <div className="card-header ">
                  <h3 className="header text-center">Cadastro</h3>
                </div>
              </div>

              <div className="card-body ">

                <Form
                  onSubmit={this.handleRegister}
                  ref={c => {
                    this.form = c;
                  }}
                >
                  {!this.state.successful && (
                    <div>
                      <div className="form-group">
                        <label htmlFor="nome">Nome</label>
                        <Input
                          id="nome"
                          type="text"
                          className="form-control"
                          name="nome"
                          value={this.state.nome}
                          onChange={this.onChangeNome}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <Input
                          id="username"
                          type="text"
                          className="form-control"
                          name="username"
                          value={this.state.username}
                          onChange={this.onChangeUsername}
                          validations={[required, vusername]}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">E-mail</label>
                        <Input
                          id="email"
                          type="text"
                          className="form-control"
                          name="email"
                          value={this.state.email}
                          onChange={this.onChangeEmail}
                          validations={[required, email]}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="password">Senha</label>
                        <Input
                          id="password"
                          type="password"
                          className="form-control"
                          name="password"
                          value={this.state.password}
                          onChange={this.onChangePassword}
                          validations={[required, vpassword]}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="unidade">Unidade: </label>
                        <select id="unidade" name="unidade" className="form-control" onChange={this.onChangeUnidade} required>
                          <option hidden>Selecione uma unidade</option>
                          <option value="CEP PROF. STÊNIO LOPES">Centro de Formação Profissional Prof. Stenio Lopes (SL)</option>
                          <option value="CEP ODILON RIBEIRO COUTINHO">Centro de Formação Profissional Odilon Ribeiro Coutinho (ORC)</option>
                          <option value="CEP JOSÉ WILLIAM LEMOS LEAL">Centro de Formação Profissional José William Lemos Leal (JWLL)</option>
                          <option value="CTCC ALBANO FRANCO">Centro de Formação Profissional e Instituto SENAI de Tecnologia do Couro e do Calçado Albano Franco (CTCC)</option>
                          <option value="CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL">CITI/CAM CENTRO DE INOV. E TEC. INDUSTRIAL (CITI/CAM)</option>
                          <option value="CFP MIRIAM BENEVIDES GADELHA">Centro de Formação Profissional Miriam Benevides Gadelha (MBG)</option>
                          {/* ISTAI fica de fora — decisão do usuário (2026-08-24), ver docs/PLANO_ITEM8_CONSTANTES.md */}
                          {/* <option value="IST AUTOMAÇÃO INDUSTRIAL">Instituto SENAI de Tecnologia em Automação (ISTAI)</option> */}
                          <option value="IST TÊXTIL E CONFECÇÕES">Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)</option>
                          <option value="IST EFICIÊNCIA OPERACIONAL">IST Eficiência Operacional (ISTEO)</option>
                          <option value="FACULDADE SENAI">FACULDADE SENAI</option>
                          <option value="ROBSON BRAGA DE ANDRADE">Robson Braga de Andrade (RBA)</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <button className="btn btn-primary btn-block">Cadastrar</button>
                      </div>
                    </div>
                  )}

                  {this.state.message && (
                    <div className="form-group">
                      <div
                        className={
                          this.state.successful
                            ? "alert alert-success"
                            : "alert alert-danger"
                        }
                        role="alert"
                      >
                        {this.state.message}
                      </div>
                    </div>
                  )}
                  <CheckButton
                    style={{ display: "none" }}
                    ref={c => {
                      this.checkBtn = c;
                    }}
                  />
                </Form>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
